import loadingGif from '../../assets/gif/FreeSensLoader05.gif';

const Loading = ({style}) => {
  return (
    <div style={style}>
      <img src={loadingGif}/>
    </div>

  );

};

export default Loading;
